// Trim all arrays to a maximum length, to minimize the size of the state
const MAX_ARRAY_LENGTH = 20;
// Sentinal value to add at end of clipped arrays
const CLIPPED_SENTINAL = 'CLIPPED';
/**
 * Sanitizes the value of an operator, to make it suitable for storing in redux.
 */
export function sanitizeValue(v) {
    if (typeof v === 'function') {
        return { type: 'function', functionName: v.name };
    }
    try {
        // If we can't stringify, it probably has cyclical references, so we'll just skip it
        return { type: 'value', value: JSON.parse(JSON.stringify(v, replacer)) };
    }
    catch (e) {
        // return {type: 'error', error: e.toString()};
        // delete the "value" property
        if (v['value'])
            delete v['value'];
        return { type: 'value', value: JSON.parse(JSON.stringify(v, replacer)) };
    }
}
/**
 * Replace long arrays with shorter ones, to minimze the size of the state
 */
function replacer(_key, value) {
    if (Array.isArray(value) && value.length > MAX_ARRAY_LENGTH) {
        const trimmed = value.slice(0, MAX_ARRAY_LENGTH);
        trimmed.push(CLIPPED_SENTINAL);
        return trimmed;
    }
    else if (value != null && typeof value == 'object') {
        const array = [];
        for (const key in value) {
            if (!value.hasOwnProperty(key)) {
                continue;
            }
            array.push(key, value[key]);
        }
        if (Array.isArray(array) && array.length > MAX_ARRAY_LENGTH) {
            const trimmed = array.slice(0, MAX_ARRAY_LENGTH);
            trimmed.push(CLIPPED_SENTINAL);
            return trimmed;
        }
    }
    return value;
}
